import { FC, ReactNode, useMemo } from 'react';
import { TableContainer } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import { getUserList } from 'api/access';
import { PublicUserInfo } from 'interfaces/profile';

import AstraTable from 'components/ui/Table/AstraTable';
import { AstraTableHeadCell } from 'components/ui/Table/AstraTableHeader';

import UserDetailsModal, {
  IUserEditModalProps,
} from '../Modals/UserDetailsModal';

const USER_TABLE_HEAD_CELL: AstraTableHeadCell<any>[] = [
  {
    id: 'username',
    numeric: false,
    disablePadding: false,
    label: 'Позывной',
  },
  {
    id: 'team',
    numeric: false,
    disablePadding: false,
    label: 'Системная роль',
  },
  {
    id: 'role',
    numeric: false,
    disablePadding: false,
    label: 'Логин',
  },
];

interface UserTableProps {
  userDetailsModalProps: IUserEditModalProps | undefined;
  setUserDetailsModalProps: React.Dispatch<
    React.SetStateAction<IUserEditModalProps | undefined>
  >;
  reload: boolean;
  triggerReload: () => void;
}

const UserTable: FC<UserTableProps> = ({
  reload,
  userDetailsModalProps,
  triggerReload,
  setUserDetailsModalProps,
}) => {
  const fetchRows = useMemo(
    () => async () => {
      const response = await getUserList();

      return {
        rows: response,
        total: response.length,
      };
    },
    [reload]
  );

  const getRoleTitle = (title: string) => {
    switch (title) {
      case 'superadmin':
        return 'Суперадмин';
      case 'admin':
        return 'Системный администратор';
      case 'user':
        return 'Пользователь';
    }
  };

  const renderRowCells: (row: PublicUserInfo) => ReactNode = (row) => {
    return (
      <>
        <TableCell align="left">
          <div className="column-with-newlines colored-title">
            {row.verboseName}
          </div>
        </TableCell>
        <TableCell align="left">
          <div className="column-with-newlines colored-title">
            {getRoleTitle(row.sysRole)}
          </div>
        </TableCell>
        <TableCell align="left">
          <div className="column-with-newlines colored-title">
            {row.username}
          </div>
        </TableCell>
      </>
    );
  };

  const handleEditRow = (userRow: PublicUserInfo) => {
    setUserDetailsModalProps({
      onClose: () => {
        setUserDetailsModalProps(undefined);
      },
      onSuccess: triggerReload,
      user: userRow,
    });
  };

  return (
    <div className="relative w-full h-full">
      <div onClick={(e) => e.stopPropagation()}>
        <TableContainer
          style={{ maxHeight: '80vh', overflowY: 'auto', width: 'full' }}
        >
          <AstraTable
            handleRowClick={(userRow) => handleEditRow(userRow)}
            fetchRows={fetchRows}
            rowIdExtractor={(row) => row.id}
            renderRowCells={renderRowCells}
            headCells={USER_TABLE_HEAD_CELL}
            isFullRowHover
          />
        </TableContainer>
        {userDetailsModalProps && (
          <UserDetailsModal {...userDetailsModalProps} />
        )}
      </div>
    </div>
  );
};

export default UserTable;
